module.exports = __webpack_public_path__ + "static/media/sendMessageBlack.bd905e66.svg";